import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Alert,
  CircularProgress
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import importService from '../../services/importService';

const ImportModule = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      // Accept both text/csv and application/vnd.ms-excel (some systems save CSV with this type)
      if (selectedFile.type === 'text/csv' || 
          selectedFile.type === 'application/vnd.ms-excel' ||
          selectedFile.name.toLowerCase().endsWith('.csv')) {
        console.log('Selected file:', selectedFile);
        setFile(selectedFile);
        setError(null);
      } else {
        setFile(null);
        setError('Please select a valid CSV file');
      }
    }
  };

  const handleImport = async () => {
    if (!file) {
      setError('Please select a file to import');
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const result = await importService.importTimecards(file);
      setSuccess(result.message);
      setFile(null);
      // Reset file input
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
    } catch (err) {
      const errorMessage = err.response?.data?.error || err.toString();
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Import Legacy Timecards
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Upload a CSV file containing legacy timecard data. The file should include:
          • Date Range column (e.g., "1/7 - 1/13")
          • Employee or Username column
          • Contract/Project column
          • Daily hours columns (Su, M, T, W, Th, F, Sa)
        </Typography>
        
        <Box sx={{ mt: 2, mb: 2 }}>
          <input
            accept=".csv,text/csv,application/vnd.ms-excel"
            style={{ display: 'none' }}
            id="raised-button-file"
            type="file"
            onChange={handleFileChange}
          />
          <label htmlFor="raised-button-file">
            <Button
              variant="outlined"
              component="span"
              startIcon={<CloudUploadIcon />}
              disabled={loading}
            >
              Select CSV File
            </Button>
          </label>
          {file && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Selected file: {file.name}
            </Typography>
          )}
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <Button
          variant="contained"
          color="primary"
          onClick={handleImport}
          disabled={!file || loading}
          sx={{ mt: 1 }}
        >
          {loading ? (
            <>
              <CircularProgress size={24} sx={{ mr: 1 }} />
              Importing...
            </>
          ) : (
            'Import Timecards'
          )}
        </Button>
      </CardContent>
    </Card>
  );
};

export default ImportModule;
